// ConfirmDialog.js
import PropTypes from 'prop-types';

import ButtonReverto from 'components/Inputs/ButtonReverto';
import TitleLayout from 'components/TitleLayout';
import './style.css';

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="confirm-dialog-container">
      <div className="confirm-dialog-content">
        <TitleLayout title={message} />
        <div className="confirm-dialog-actions">
          <ButtonReverto onClick={onConfirm } style={{ backgroundColor : "var(--bleu1-dark)" , border : "1px solid var(--bleu2)" , color : "var(--blanc)"}} >Confirmer</ButtonReverto>
          <ButtonReverto onClick={onCancel}>Annuler</ButtonReverto>
        </div>
      </div>
    </div>
  );
};

ConfirmDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog;